export const profile = {
  profileFavoritesIconTitle: 'Favoritai',
  profileEditIconTitle: 'Redaguoti',
  profileShareIconTitle: 'Dalintis',
  profileAdditionalSectionTitle: 'Papildoma informacija',
  profileFavoritesCurtainTitle: 'Favoritai',
  profileFavoriteActionTitle: 'Pridėti prie favoritų',
  profileFavoritedActionTitle: 'Pridėta prie favoritų',
  profileMessageAction: 'Žinutė',
  profileCurtainAdd: 'Pridėti',
  profileReportUser: 'Pažymėti vartotoją',
  profileReportTitle: 'Pažymėti',
  profileReportSuccess: 'Turinys pažymėtas',
  profileReset: 'Atstatyti',
  profileApply: 'Taikyti',
  profileCustomInvalidEmail: 'nėra galiojantis el. pašto adresas',
  profileMaxContentSizeError: 'Viršytas maksimalus turinio dydis!',
  profileMaxAvatarSizeError: 'Jūsų avataro dydis per didelis!',
  profileFavoritesCurtainSearchInputText: 'Ieškoti',
  profileTapShareCurtainOptionTitle: 'Kopijuoti nuorodą',
  profileTapShareLinkCopiedAlertTitle: 'Nuoroda nukopijuota!',
  profileQrShareCurtainTitle: 'Dalintis profiliu',
  profileQrShareCurtainShareButtonTitle: 'Dalintis',
  profileQrShareCurtainCopyButtonTitle: 'Kopijuoti nuorodą',
  profileQrShareCurtainCopiedAlertTitle: 'Nuoroda nukopijuota!',
  profileQrTapShareProfileCurtainTitle: 'Dalinkitės savo profiliu',
  profileEditTitle: 'Redaguoti',
  profileEditPersonalSectionTitle: 'Asmeniniai duomenys',
  profileEditContactsSectionTitle: 'Kontaktai',
  profileEditSocialSectionTitle: 'Socialiniai tinklai',
  profileEditAddSocialButtonTitle: 'Pridėti socialinį tinklą',
  profileEditAdditionalSectionTitle: 'Papildoma informacija',
  profileEditSaveButtonTitle: 'Išsaugoti',
  profileEditSavedAlertTitle: 'Profilis išsaugotas!',
  profileEditEmptyRequiredInputTitle: 'Laukas negali būti tuščias',
  profileEditEmptyRequiredEmailInputTitle: 'Viešasis el. paštas nėra galiojantis el. pašto adresas',
  profileEditEmptyRequiredErrorTitle: 'Įvyko klaida!',
  profileEditSocialsHint: 'Įveskite savo socialinio profilio URL',
  preferences: 'Nustatymai',
  interestedIn: 'Domiuosi',
  expertIn: 'Esu ekspertas',
  myPitch: 'Mano pristatymas',
  qrBadge: 'QR ženklelis',
  touchpoints: 'Kontaktai',
  lookingFor: 'Ieškau',
  topicsToDiscuss: 'Diskusijų temos',
  createNew: 'Sukurti naują',
  viewTopic: 'Peržiūrėti temą',
  join: 'Prisijungti',
  hobbyInterests: 'Pomėgiai ir interesai',
  myNetwork: 'Mano tinklas',
  seeAll: 'Žiūrėti visus',
  checkThemOut: 'Pažiūrėkite juos!',
  activities: 'Veiklos',
  oneOnOne: '1:1 susitikimas',
  Leaderboard: 'Lyderių lenta',
  learnNetworking: 'Sužinokite daugiau apie Tinklaveikos centrą',
  networkingGroup: 'Tinklaveikos grupė',
  networkingLevel: 'Tinklaveikos lygis',
  message: 'Žinutė',
  scheduleOneOnOne: 'Suplanuoti 1:1',
  addNote: 'Pridėti pastabą',
  notes: 'Pastabos',
  enterNote: 'Įveskite pastabą',
  shareUserProfile: 'Dalintis vartotojo profiliu',
  flagUser: 'Pažymėti vartotoją'
}
